import React from 'react'
import useTreatments from '../../store/treatments/treatmentsContext';
import useCalendly from '../../store/appointments/appointmentsContext';
import MoonLoader from 'react-spinners/MoonLoader'
import { COLORS } from '../../config';
import SecondaryButtonAccent from '../../components/Buttons/SecondaryButtonAccent';
import PlusIcon from '../../components/Icons/solid/PlusIcon';
import AddAppointmentModal from './AddAppointmentModal';
import AppointmentCard from '../../components/Cards/AppointmentCard';

function TreatmentAppointment({ treatmentInfo, user }) {

    const {
        treatmentsState : { treatmentCollaborators },
        getTreatmentCollaborators
    } = useTreatments();

    const treatmentId = treatmentInfo._id;


    const { 
        getTreatmentAppointments,
        addAppointment
    } = useCalendly();

    const [isLoading, setIsLoading] = React.useState(true);

    const [ treatmentAppointments, setTreatmentAppointments ] = React.useState([]);

    const fetchAppointments = async () => {
        await getTreatmentAppointments(treatmentId).then(res => {
            const appointments = res.data?.data;
            if (appointments) setTreatmentAppointments(appointments);
            setIsLoading(false);
        })
    }

    const fetchTreatmentCollaborators = async () => {
        await getTreatmentCollaborators(treatmentId)
    }

    React.useEffect(() => {
        if(treatmentId){
            fetchTreatmentCollaborators()
            fetchAppointments()    
        }
      
    }, [treatmentId]);

  const [showAddAppointment, setShowAddAppointment] = React.useState(false);

  return (
    <div className={`bg-white rounded mt-4 shadow flex flex-col pb-4 pt-10 flex-grow ${treatmentAppointments.length ? 'h-96' : 'h-auto'} `}>
        <AddAppointmentModal 
            treatmentInfo={treatmentInfo} 
            treatmentCollaborators={treatmentCollaborators} 
            showAddAppointment={showAddAppointment} 
            setShowAddAppointment={setShowAddAppointment} 
            addAppointment={addAppointment}
            fetchAppointments={fetchAppointments}
        />
        <div className='flex px-10 justify-between'>
            <h1 className="text-2xl text-secondary">Appointments</h1>
            {user.user_type !== "patient" && 
            <SecondaryButtonAccent 
                onClick={() => setShowAddAppointment(true)} 
                text="Add appointment" 
                icon={<PlusIcon fill={COLORS.colorPrimary}/>}
            />}
        </div>
        {isLoading && 
        <div className='flex justify-around min-h-170 pt-8'>
            <MoonLoader color={COLORS.colorPrimary}/>
        </div> 
        }
        {!isLoading && (treatmentAppointments.length ? 
        <div className='h-full px-10 mt-4 overflow-x-hidden overflow-y-auto mr-4'>
            {treatmentAppointments.map((appointment, index) => {
                return (
                <div key={appointment.uri} className={`${index !== 0 && 'mt-4'} -mr-4`}>
                    <AppointmentCard appointment={appointment}/>
                </div>
                )
            })}
        </div> 
         : <span className='mt-8 px-10 pb-6'>No appointments are currently set for this treatment.</span> 
        )}
    </div>
  )
}

export default TreatmentAppointment


